// extracted by mini-css-extract-plugin
export default {"wrapper":"TextFields_wrapper__x0kSP","input":"TextFields_input__F2pQP","input__label":"TextFields_input__label__6J23C"};